import React, { useEffect } from 'react';
import DataQualityForm from './DataQualityForm';
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import TrafficMonitoring from './TrafficMonitoring';

function BarHandler({ type, setSuccessSB, setErrorSB }) {

    console.log("BarHandler:", setSuccessSB, setErrorSB );
    useEffect(() => {

    }, [type])

    function CaseRender() {
        switch (type) {
            case "DataQuality":
                return <DataQualityForm setSuccessSB={setSuccessSB} setErrorSB={setErrorSB} />;
            case "TrafficMonitoring":
                return <TrafficMonitoring />;
            case "Events":
                return <></>;
            case "Scenarios":
                return <></>;
            default:
                return <></>
        }
    }
    return (
        <Card style={{ marginTop: '20px', padding: '12px', height: '100%' }}>
            <CaseRender />
        </Card>
    );
}

export default BarHandler;